// BRICS Sustainable Lifestyle Week 2026 — the IEC hoardings, one per action,
// plus the combined sheet. The files live under Frontend/public/assets/bslw
// (served as static assets, not bundled) so the popup loads thumbnails and the
// download link hands over the full 2934x1650 artwork.
const BASE = "/assets/bslw";

export const BSLW_POSTER_PACK = `${BASE}/BSLW-IEC-Material.pdf`;

export const BSLW_POSTERS = [
  { key: "seven-actions", title: "Seven Actions", file: `${BASE}/seven-actions.jpg`, thumb: `${BASE}/thumbs/seven-actions.jpg` },
  { key: "say-no-to-single-use-plastic", title: "Say No to Single-use Plastics", file: `${BASE}/say-no-to-single-use-plastic.jpg`, thumb: `${BASE}/thumbs/say-no-to-single-use-plastic.jpg` },
  { key: "adopt-healthy-lifestyles", title: "Adopt Healthy Lifestyles", file: `${BASE}/adopt-healthy-lifestyles.jpg`, thumb: `${BASE}/thumbs/adopt-healthy-lifestyles.jpg` },
  { key: "save-energy", title: "Save Energy", file: `${BASE}/save-energy.jpg`, thumb: `${BASE}/thumbs/save-energy.jpg` },
  { key: "save-water", title: "Save Water", file: `${BASE}/save-water.jpg`, thumb: `${BASE}/thumbs/save-water.jpg` },
  { key: "reduce-waste", title: "Reduce Waste", file: `${BASE}/reduce-waste.jpg`, thumb: `${BASE}/thumbs/reduce-waste.jpg` },
  { key: "sustainable-food-systems", title: "Adopt Sustainable Food Systems", file: `${BASE}/sustainable-food-systems.jpg`, thumb: `${BASE}/thumbs/sustainable-food-systems.jpg` },
  { key: "reduce-ewaste", title: "Reduce E-waste", file: `${BASE}/reduce-ewaste.jpg`, thumb: `${BASE}/thumbs/reduce-ewaste.jpg` },
];
